const steps = [
  { number: '01', icon: 'ri-phone-line', title: 'Premier Contact', description: 'Appelez-nous ou envoyez un message. Nous évaluons vos besoins et ceux de votre proche pour proposer la solution la plus adaptée.' },
  { number: '02', icon: 'ri-user-heart-line', title: 'Évaluation à Domicile', description: 'Un responsable se déplace gratuitement pour rencontrer la personne et évaluer ses besoins spécifiques dans son environnement.' },
  { number: '03', icon: 'ri-file-text-line', title: 'Plan d\'Accompagnement', description: 'Nous établissons un plan personnalisé avec les horaires, les tâches et la fréquence des interventions selon vos souhaits.' },
  { number: '04', icon: 'ri-heart-line', title: 'Suivi Régulier', description: 'Un suivi régulier est assuré pour adapter les prestations à l\'évolution des besoins. Votre satisfaction est notre priorité.' },
];

export default function AideDomicileProcess() {
  return (
    <section className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-orange-400 mb-2">Notre Approche</h2>
          <p className="text-4xl font-bold text-white mb-4">Comment ça fonctionne ?</p>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Un accompagnement simple et humain, pensé pour vous et votre proche.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 h-0.5 bg-orange-500/20 z-0" style={{ width: 'calc(100% - 2.5rem)', left: '2.5rem' }}></div>
              )}
              <div className="relative z-10 text-center">
                <div className="relative inline-flex">
                  <div className="w-20 h-20 flex items-center justify-center bg-orange-500 rounded-2xl mx-auto mb-5">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <span className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center bg-gray-700 text-orange-400 text-xs font-bold rounded-full border border-orange-500/40">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Valeurs */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: 'ri-shield-user-line', title: 'Discrétion & Respect', desc: 'Nous intervenons dans l\'intimité du domicile avec le plus grand respect de la personne, de ses habitudes et de sa dignité.' },
            { icon: 'ri-group-line', title: 'Personnel Qualifié', desc: 'Nos intervenants sont sélectionnés, formés et accompagnés. Ils bénéficient d\'une formation continue pour garantir un service de qualité.' },
            { icon: 'ri-refresh-line', title: 'Continuité du Service', desc: 'En cas d\'absence de votre intervenant habituel, un remplaçant qualifié prend le relais pour assurer la continuité des prestations.' },
          ].map((val, i) => (
            <div key={i} className="bg-gray-800 rounded-2xl p-6 border border-gray-700 hover:border-orange-500/40 transition-all">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500/20 rounded-xl mb-4">
                <i className={`${val.icon} text-2xl text-orange-400`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{val.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
